import { render, staticRenderFns } from "./MenuTagCounter.vue?vue&type=template&id=1001707b"
import script from "./MenuTagCounter.vue?vue&type=script&lang=js"
export * from "./MenuTagCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports